import axios from 'axios';

const STORAGE_KEYS = {
  SELECTED_TENANT: 'inmocms_selected_tenant',
  TENANT_CONFIG: 'inmocms_tenant_config',
  LAST_FETCH: 'inmocms_tenant_last_fetch',
} as const;

// Create axios instance with base configuration
const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'https://api.redraiz.co/api/v1',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor
api.interceptors.request.use(
  (config) => {
    // Add auth token if available
    const token = localStorage.getItem('inmocms_auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
      const cachedConfig = localStorage.getItem(STORAGE_KEYS.TENANT_CONFIG);

    if(cachedConfig){
      
      config.headers['x-tenant-id'] = JSON.parse(cachedConfig || '{}')?.id;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle common errors
    // Only redirect to login if we had a token (authenticated request) and it was rejected
    // Public endpoints (like /pages/slug/servicios) should fail gracefully without redirect
    if (error.response?.status === 401) {
      const hadToken = !!localStorage.getItem('inmocms_auth_token');
      if (hadToken) {
        // Token was invalid or expired - clear and redirect
        localStorage.removeItem('inmocms_auth_token');
        localStorage.removeItem('inmocms_user_session');
        window.location.href = '/login';
      }
      // If no token, let the error propagate for graceful handling with fallback data
    }
    return Promise.reject(error);
  }
);

export default api;